import React from "react";
import Filters from "../../components/filters/Filters";
import Transactions from "../../components/payments/transactions/Transactions";
import TransactionGraph from "../../components/payments/graph/TransactionGraph";
import TransactionGraphWithTrends from "../../components/payments/graph/TransactionGraphWithTrends";

const LoadPayments = () => {
  return (
    <section className="flex flex-col space-y-8">
      <section>
        {/* <TransactionGraph /> */}
        <TransactionGraphWithTrends />
      </section>
      <Filters />
      <Transactions />
    </section>
  );
};

export default LoadPayments;
